import '.c0{position:relative;}.ssr-plugin'
import '.a6{width:100%;}.ssr-plugin'
import '.fz{min-height:200px;}.ssr-plugin'
import '.g{display:flex;}.ssr-plugin'
import '.k{flex-direction:column;}.ssr-plugin'
import '.h{justify-content:center;}.ssr-plugin'
import '.bt{align-items:flex-start;}.ssr-plugin'
import '.f{padding:2rem;}.ssr-plugin'
import '.cv{background:var(--shades-white);}.ssr-plugin'
import '.w{overflow:hidden;}.ssr-plugin'
import '.s{position:absolute;}.ssr-plugin'
import '.il{top:50%;}.ssr-plugin'
import '.im{right:1rem;}.ssr-plugin'
import '.in{transform:translateY(-50%);}.ssr-plugin'
import '.io{width:120px;}.ssr-plugin'
import '.ip{height:120px;}.ssr-plugin'
import '.iq{z-index:0;}.ssr-plugin'
import '.l{align-items:center;}.ssr-plugin'
import '.h1{z-index:1;}.ssr-plugin'
import '.bf{gap:0.5rem;}.ssr-plugin'
import '.ir{max-width:calc(100% - 140px);}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="c0 a6 fz g k h bt f cv w"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="s il im in io ip iq g l h"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="c0 h1 g k bt bf ir"
      >
        {/* Bold Number */}
        <Title.H1
          style={{
            fontSize: '4rem',
            fontWeight: '700',
            lineHeight: '100%',
            margin: 0,
            color: 'var(--primary-blue)',
            fontFamily: 'FunnelDisplay',
          }}
        >
          {number}
        </Title.H1>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--primary-blue)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
